'use es6';

import { createSelector } from 'reselect';
import { pick } from 'underscore';
import * as DragDropItemTypes from 'DesignData/enums/DragDropItemTypes';
/*
 *
 * Basic Selectors
 *
 */

export const getSharedDragDropContextMonitor = state => state.sharedDragDropContext.monitor;
/*
 *
 * Reselelect Selector Factories
 *
 */

/**
 * @param  {Object} itemTypes DragDropItemTypes to check dragged item type against.
 * @return {Boolean} True if selector should expect a drop, false otherwise.
 */

const makeIsDraggingSelector = itemTypes => () => {
  return createSelector([getSharedDragDropContextMonitor], monitor => {
    if (monitor.isDragging === false) {
      return false;
    }

    return !!itemTypes[monitor.itemType];
  });
}; // Types that signify the layout editor can expect a drop.


const LAYOUT_IS_DRAGGING_TYPES = pick(DragDropItemTypes, [DragDropItemTypes.LAYOUT_ROW, DragDropItemTypes.LAYOUT_WIDGET, DragDropItemTypes.LAYOUT_CELL, DragDropItemTypes.LAYOUT_VIRTUAL_CELL, DragDropItemTypes.LAYOUT_FLEX_COLUMN, DragDropItemTypes.LAYOUT_CUSTOM_WIDGET, DragDropItemTypes.LAYOUT_GLOBAL_GROUP, DragDropItemTypes.LAYOUT_GLOBAL_WIDGET, DragDropItemTypes.LAYOUT_SECTION_DELIMITER, DragDropItemTypes.LAYOUT_SECTION_DELIMITER_ROW, DragDropItemTypes.WIDGET_SIDEBAR_WIDGET, DragDropItemTypes.WIDGET_SIDEBAR_CELL, DragDropItemTypes.WIDGET_SIDEBAR_VIRTUAL_CELL, DragDropItemTypes.WIDGET_SIDEBAR_FLEX_COLUMN, DragDropItemTypes.WIDGET_SIDEBAR_CUSTOM_WIDGET, DragDropItemTypes.WIDGET_SIDEBAR_GLOBAL_GROUP, DragDropItemTypes.WIDGET_SIDEBAR_GLOBAL_WIDGET, DragDropItemTypes.FINDER_FILE]);
export const makeGetLayoutIsDragging = makeIsDraggingSelector(LAYOUT_IS_DRAGGING_TYPES); // Types that signify the finder can expect a drop.

const FINDER_IS_DRAGGING_TYPES = pick(DragDropItemTypes, [DragDropItemTypes.FINDER_FILE, DragDropItemTypes.FINDER_FOLDER]);
export const makeGetFinderIsDragging = makeIsDraggingSelector(FINDER_IS_DRAGGING_TYPES);